// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__263P1","empty":"ModalGraph_empty__2EZbQ"};